import {EditPageDocument, Page} from "generated/graphql";
import {useMutation} from "@apollo/client";

export const useEditPage = () => {
  const [mutate] = useMutation(EditPageDocument);

  return (page: Page) => mutate({ variables: { input: { page } } });
}